/**
 * EmailSignUpForm.js
 *
 * Handles both sign-in and sign-up via email/password.
 * In sign-up mode, also asks for displayName and phoneNumber.
 */

import React, { useState } from "react";

const EmailSignUpForm = ({ mode, signIn, signUp, onSuccess }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            if (mode === "signin") {
                await signIn(email, password);
            } else {
                await signUp(email, password, { displayName, phoneNumber });
            }
            onSuccess();
        } catch (err) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="flex flex-col space-y-4"
        >
            {mode === "signup" && (
                <>
                    <input
                        type="text"
                        placeholder="Full Name"
                        className="border border-zinc-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-zinc-400"
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        required
                    />
                    <input
                        type="tel"
                        placeholder="Phone Number"
                        className="border border-zinc-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-zinc-400"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        required
                    />
                </>
            )}

            <input
                type="email"
                placeholder="Email"
                className="border border-zinc-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-zinc-400"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />

            <input
                type="password"
                placeholder="Password"
                className="border border-zinc-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-zinc-400"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
            />

            {error && <p className="text-red-500 text-sm text-center">{error}</p>}

            <button
                type="submit"
                disabled={loading}
                className="
                    border border-zinc-300 rounded-lg py-2 font-medium
                    hover:bg-zinc-200 transition-colors disabled:opacity-50
                "
            >
                {loading
                    ? "Please wait..."
                    : mode === "signin"
                    ? "Sign In"
                    : "Sign Up"}
            </button>
        </form>
    );
};

export default EmailSignUpForm;